import { render, staticRenderFns } from "./PayButton.vue?vue&type=template&id=2b0b6277&scoped=true"
import script from "./PayButton.vue?vue&type=script&lang=js"
export * from "./PayButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0b6277",
  null
  
)

export default component.exports